import { defineComponent as _defineComponent } from 'vue'
import { IMessenger } from "@/api/types/user";
import SvgArrow from "@/assets/icons/arrow-down.svg";
import { IMessengerItem, MESSENGER, messengerItems } from "@/mappings/messengers";
import { computed, onMounted, ref } from "vue";

interface Props {
    value: IMessenger;
    isClearable?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MessengerSelect',
  props: {
    value: null,
    isClearable: { type: Boolean }
  },
  emits: ['update:value'],
  setup(__props: any, { emit }) {

const props = __props as {
    value: IMessenger;
    isClearable?: boolean;
}




const messengerType = ref('');
const messengerAccount = ref('');
const isShowSelect = ref(false);

const getSelectedLogo = computed(() => {
    return messengerItems.find((el) => el.type === messengerType.value)?.logo;
});

const getNotSelectedItems = computed(() => {
    return messengerItems.filter((el) => el.type !== messengerType.value);
});

const isTeamsEmailError = computed(() => {
    if (messengerType.value !== MESSENGER.TEAMS || !messengerAccount.value) return false;
    return !/^[\w.-]+@([\w-]+\.)+[\w-]{2,}$/.test(messengerAccount.value);
});

const toggleSelect = () => {
    isShowSelect.value = !isShowSelect.value;
};

const closeSelect = () => {
    isShowSelect.value = false;
};

const selectType = (item: IMessengerItem) => {
    messengerType.value = item.type;
    messengerAccount.value = '';
    updateValue();
};

const input = ({ target: { value } }: Event) => {
    if (value === '') {
        clearValue();
    } else {
        updateValue();
    }
};

const updateValue = () => {
    const value = { type: messengerType.value, account: messengerAccount.value };
    emit('update:value', value);
};

const clearValue = () => {
    messengerType.value = '';
    messengerAccount.value = '';
    emit('update:value', null);
};

onMounted(() => {
    if (!props.value.account && !props.value.type) return;
    messengerType.value = messengerItems.find((el) => el.type === props.value.type).type;
    messengerAccount.value = props.value.account;
});

return { __sfc: true,props, emit, messengerType, messengerAccount, isShowSelect, getSelectedLogo, getNotSelectedItems, isTeamsEmailError, toggleSelect, closeSelect, selectType, input, updateValue, clearValue, SvgArrow }
}

})